import { CalendarDateTime } from '@internationalized/date'

/**
 * Converts a Date to CalendarDateTime using the runtime's local timezone
 * (getFullYear(), getMonth(), getDate(), getHours(), getMinutes()).
 * Only use in CLIENT components (e.g. date pickers, forms). Using during SSR
 * can cause hydration mismatch if server and client timezones differ.
 */
export const getLocalizedDate = (initalDate?: Date): CalendarDateTime => {
    if (!initalDate) {
        const now = new Date()
        return new CalendarDateTime(
            now.getFullYear(),
            now.getMonth() + 1,
            now.getDate(),
            now.getHours(),
            now.getMinutes()
        )
    }

    // Ensure we have a valid Date object
    const date = new Date(initalDate)

    // Check if the date is valid
    if (isNaN(date.getTime())) {
        const now = new Date()
        return new CalendarDateTime(
            now.getFullYear(),
            now.getMonth() + 1,
            now.getDate(),
            now.getHours(),
            now.getMinutes()
        )
    }

    return new CalendarDateTime(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes()
    )
}
